import { styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const VerticalDelimiterStyled = styled('div')(() => ({
  width: 0.5,
  height: 12,
  backgroundColor: Colors.gray300,
}));
